import jsCookie from "js-cookie";

interface Cookie {
  key: string;
  value: string;
}

export const getCookie = (key: string): string | undefined => jsCookie.get(key);

export const setCookie = ({ key, value }: Cookie): string | undefined =>
  jsCookie.set(key, value);

export const removeCookie = (key: string): void => jsCookie.remove(key);
